"use client"

import { motion } from "framer-motion"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"

const faqs = [
  {
    q: "What should I expect during my first therapy session?",
    a: "The first session focuses on understanding your history, current challenges, and goals for therapy. It's an opportunity to build rapport with your therapist in Greensboro and discuss which approaches, like EMDR or trauma-focused strategies, will work best.",
  },
  {
    q: "How are EMDR intensives different from regular therapy sessions?",
    a: "EMDR intensives condense multiple hours of therapy into consecutive days for focused, uninterrupted work. This approach can accelerate processing and help clients make meaningful progress in a shorter timeframe.",
  },
  {
    q: "Does your mental health clinic in Greensboro ensure therapy sessions are confidential?",
    a: "Yes, all sessions are fully confidential in accordance with state laws and professional ethical standards. Your privacy is a top priority in every interaction.",
  },
  {
    q: "Can therapy be combined with other treatments or supports?",
    a: "Therapy can complement medications, medical care, or community support programs. Your therapist can coordinate approaches to ensure your overall care is consistent and effective.",
  },
  {
    q: "How do I get started?",
    a: "Reach out to our team of trauma therapists in Greensboro so we can learn more about what you need and help connect you with the right service. From there, we can answer questions about scheduling, availability, and the next steps for care.",
  },
]

const FAQSection = () => {
  return (
    <section id="faq" className="section-padding bg-background">
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="text-sm font-medium tracking-[0.18em] uppercase text-[hsl(var(--terracotta))] mb-3">
            Have Questions?
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-foreground mb-4 leading-snug">
            Frequently Asked Questions
          </h2>
          <div className="w-14 h-0.5 bg-[hsl(var(--sage))] mx-auto" />
        </motion.div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white border border-[hsl(var(--border))] rounded-2xl px-6 data-[state=open]:shadow-sm transition-shadow"
            >
              <AccordionTrigger className="text-left font-heading text-base font-semibold text-foreground hover:no-underline py-5 hover:text-[hsl(var(--terracotta))] transition-colors">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  )
}

export default FAQSection
